import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
interface Testimonial {
  initials: string;
  location: string;
  text: string;
}
interface TestimonialsProps {
  testimonials: Testimonial[];
  className?: string;
}
export function Testimonials({
  testimonials,
  className = ''
}: TestimonialsProps) {
  return <section className={`py-16 px-4 ${className}`} data-id="element-305">
      <div className="max-w-6xl mx-auto" data-id="element-306">
        <div className="grid md:grid-cols-3 gap-6" data-id="element-307">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-brand-card p-6 rounded-2xl border border-white/5 hover:border-brand-gold/30 transition-colors" data-id="element-308">
              <div className="flex gap-1 mb-4" data-id="element-309">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-310" />)}
              </div>
              <p className="text-gray-300 mb-6 italic" data-id="element-311">"{t.text}"</p>
              <div className="flex items-center gap-3" data-id="element-312">
                <div className="w-10 h-10 rounded-full bg-brand-dark flex items-center justify-center border border-brand-gold/20 text-brand-gold font-bold" data-id="element-313">
                  {t.initials}
                </div>
                <div data-id="element-314">
                  <div className="font-bold text-sm" data-id="element-315">{t.initials}</div>
                  <div className="text-xs text-gray-500" data-id="element-316">{t.location}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}